import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import { useEffect, FC, PropsWithChildren } from 'react'
import { createTheme, CssBaseline, ThemeOptions, ThemeProvider } from '@mui/material'
import { useRecoilValue } from 'recoil'

import { themeState } from '../common/state'
import { grey } from '@mui/material/colors'

export const darkThemeOptions: ThemeOptions = {
  palette: {
    mode: 'dark',
    secondary: {
      main: '#4CAF50',
      contrastText: '#fff',
    },
    background: {
      default: '#333',
    },
    text: {
      primary: '#fff',
      secondary: grey[500],
    },
  },
}

export const lightThemeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    secondary: {
      main: '#4CAF50',
      contrastText: '#fff',
    },
    background: {
      default: '#f1f5f6',
    },
  },
}

export const Theme: FC<PropsWithChildren> = ({ children }) => {
  const theme = useRecoilValue(themeState)
  const themeOptions = theme === 'light' ? lightThemeOptions : darkThemeOptions
  const healthHelperTheme = createTheme(themeOptions)

  useEffect(() => {
    document.body.style.backgroundColor = healthHelperTheme.palette.background.default
  }, [healthHelperTheme.palette.background.default])

  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={healthHelperTheme}>{children}</ThemeProvider>
    </>
  )
}
